'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.emptyNode = emptyNode;
exports.initCardLazyLoading = initCardLazyLoading;
exports.initBgLazyLoading = initBgLazyLoading;
exports.debounce = debounce;
exports.isOutOfViewport = isOutOfViewport;
exports.isInViewport = isInViewport;

var _blazy = require('blazy');

var _blazy2 = _interopRequireDefault(_blazy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function emptyNode(node) {
	while (node.firstChild) {
		node.removeChild(node.firstChild);
	}
}

function initCardLazyLoading() {
	var bLazy = new _blazy2.default({
		breakpoints: [{
			width: 420,
			src: 'data-src-small'
		}, {
			width: 768,
			src: 'data-src-medium'
		}],
		success: function success(element) {
			var card = element.closest('.js-card');
			setTimeout(function () {
				card.className = card.className.replace('loading', 'loaded');
			}, 200);
		}
	});

	return bLazy;
}

function initBgLazyLoading() {
	var lazyBanners = new _blazy2.default({
		selector: '.js-lazyBanner'
	});

	return lazyBanners;
}

function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
		    args = arguments;
		var later = function later() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

function isOutOfViewport(elem) {
	// Get element's bounding
	var bounding = elem.getBoundingClientRect();

	// Check if it's out of the viewport on each side
	var out = {};
	out.top = bounding.top < 0;
	out.left = bounding.left < 0;
	out.bottom = bounding.bottom < 0;
	out.right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
	out.any = out.top || out.left || out.bottom || out.right;
	out.all = out.top && out.left && out.bottom && out.right;

	return out;
};

function isInViewport(elem) {
	var distance = elem.getBoundingClientRect();

	return distance.top >= 0 && distance.left >= 0 && distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) && distance.right <= (window.innerWidth || document.documentElement.clientWidth);
};